import { ReactNode } from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

type Props = {
  icon?: ReactNode;
  /** Icon color inside the navy circle. */
  iconTone?: 'white' | 'teal' | 'blue';
  title: ReactNode;
  primaryLabel?: string;
  primaryTo?: string;
  primaryHref?: string;
  className?: string;
};

export default function GradientCTA({
  icon,
  iconTone = 'white',
  title,
  primaryLabel = 'Book a 30 Min Call',
  primaryTo = '/book-a-call',
  primaryHref,
  className,
}: Props) {
  const iconWrapClass =
    iconTone === 'teal'
      ? 'cta-gradient-bar__icon-wrap cta-gradient-bar__icon-wrap--teal'
      : iconTone === 'blue'
        ? 'cta-gradient-bar__icon-wrap cta-gradient-bar__icon-wrap--blue'
        : 'cta-gradient-bar__icon-wrap';

  return (
    <div className={`cta-gradient-bar text-white py-5 ${className ?? ''}`}>
      <Container className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-4">
        <div className="d-flex align-items-center gap-3">
          {icon ? <div className={iconWrapClass}>{icon}</div> : null}
          <div className="cta-gradient-bar__copy sbr-cta__title fw-semibold">
            {title}
          </div>
        </div>
        <div className="flex-shrink-0">
          {primaryHref ? (
            <Button variant="dark" size="lg" href={primaryHref}>
              {primaryLabel} <i className="bi bi-arrow-right ms-2" aria-hidden />
            </Button>
          ) : (
            <Button variant="dark" size="lg" as={Link as any} to={primaryTo}>
              {primaryLabel} <i className="bi bi-arrow-right ms-2" aria-hidden />
            </Button>
          )}
        </div>
      </Container>
    </div>
  );
}
